import axios from '../axios';
import { BRANCH_FORGOT_PASSWORD } from '../ApiUrl';

/**
 * POST /BranchForgotPassword — no auth. Body: `{ email }`.
 * HTTP 200: `success` + `CustomMessage` (unknown email vs email sent).
 */
export const branchForgotPasswordAPI = async (payload) => {
  try {
    const response = await axios.post(BRANCH_FORGOT_PASSWORD, payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response;
  } catch (error) {
    console.log('branchForgotPasswordAPI catch block', error);
    return { hasError: true, error };
  }
};
